var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.926 12.25L3.86345 0.462469C3.51251 0.257814 3.10839 0.162746 2.70301 0.189474C2.29763 0.216202 1.90949 0.363507 1.58845 0.612469C1.26059 0.871154 1.02254 1.22655 0.9081 1.62819C0.793665 2.02984 0.808658 2.45733 0.950953 2.84997L4.46345 12.6625C4.49899 12.7603 4.56347 12.845 4.64832 12.9053C4.73317 12.9656 4.83437 12.9986 4.93845 13H13.9635C14.2229 12.9959 14.4743 13.0903 14.6669 13.2643C14.8594 13.4383 14.9788 13.6789 15.001 13.9375C15.0095 14.074 14.99 14.2107 14.9435 14.3394C14.8971 14.468 14.8248 14.5858 14.7311 14.6853C14.6374 14.7849 14.5242 14.8642 14.3986 14.9183C14.2731 14.9725 14.1377 15.0002 14.001 15H4.93845C4.83437 15.0013 4.73317 15.0344 4.64832 15.0946C4.56347 15.1549 4.49899 15.2396 4.46345 15.3375L0.950953 25.15C0.845561 25.4523 0.813803 25.7753 0.858319 26.0924C0.902835 26.4094 1.02234 26.7112 1.20691 26.9728C1.39148 27.2344 1.63578 27.4481 1.91954 27.5963C2.2033 27.7446 2.51832 27.8229 2.83845 27.825C3.17911 27.8234 3.51409 27.7375 3.81345 27.575L24.926 15.75C25.2353 15.5743 25.4925 15.3198 25.6714 15.0124C25.8504 14.705 25.9446 14.3557 25.9446 14C25.9446 13.6443 25.8504 13.2949 25.6714 12.9875C25.4925 12.6801 25.2353 12.4256 24.926 12.25Z",
    fill: "url(#paint0_linear_4016_393)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4016_393",
    x1: 0.832031,
    y1: 27.825,
    x2: 28.3454,
    y2: 2.82737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD2477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36E36"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendSvg);
export default __webpack_public_path__ + "static/media/SendSVG.a8245d5fec61138f4e3e2f210bfb3cde.svg";
export { ForwardRef as ReactComponent };